import { ref, type Ref } from 'vue';

const state: Record<string, Ref<unknown>> = {};

/**
 * Plain-Vue stand-in for Nuxt's `useState`, wired to `#imports` by the host's
 * Vite alias (admin, Storybook, Vitest). Nuxt resolves `#imports` itself, so
 * there the real per-request `useState` is used instead.
 */
export const useState = <T>(key: string, init: () => T): Ref<T> => {
  const existing = state[key];
  if (existing) {
    return existing as Ref<T>;
  }
  const value = ref(init()) as Ref<T>;
  state[key] = value;
  return value;
};
